export const fileMaxSize5MB = 5 * 1024 * 1024;
export const fileMaxSize10MB = 10 * 1024 * 1024;

export enum FILE_CONTENT_TYPE {
  FORM_DATA = 'multipart/form-data',
  PDF = 'application/pdf',
  JPEG = 'image/jpeg',
  PNG = 'image/png',
}

export enum LANGUAGES {
  fr = 'fr',
  en = 'en',
  es = 'es',
  de = 'de',
  nl = 'nl',
  pl = 'pl',
}

export enum CROSSING_DIRECTION_CITY {
  Ca = 'Ca',
  Fo = 'Fo',
  CALAIS = 'Calais',
  FOLKESTONE = 'Folkestone',
}

export enum CROSSING_DIRECTION_COUNTRY {
  UKEU = 'UKEU',
  EUUK = 'EUUK',
}

export enum COUNTRIES_NAME {
  GB = 'GB',
  EU = 'EU',
}

export enum TRAILER_LOAD_MODE {
  FULL = 'Full',
  EMPTY = 'Empty',
}

export enum FOLDER_STATUS_REFERENTIAL_BORDER_CROSSING_RORO {
  FOLDER_STATUS_PENDING_REQUEST = 'de2ceda3-366c-4045-8e37-3f167373f148',
  FOLDER_STATUS_EXPIRED_REQUEST = '853acb07-f5e5-4a82-b013-9cb8834008a3',
  FOLDER_STATUS_CANCELLED_REQUEST = '3b86827b-f591-4080-8e22-db2862f6d259',
  FOLDER_STATUS_PENDING_ORDER = '3a9ec2e9-1e5e-4a76-9434-b8821f5a86ff',
  FOLDER_STATUS_DOCUMENTARY_INCIDENT = 'fbd176bf-bf7a-40db-ad55-bf9b33dcd17e',
  FOLDER_STATUS_DOCUMENTARY_INCIDENT_TREATED = '0503f475-8b3f-4228-b2c9-e423c5890fbc',
  FOLDER_STATUS_EXPIRED_ORDER = '29aa52a8-ca68-4c27-91c4-cf831f87058a',
  FOLDER_STATUS_CANCELLED_ORDER = 'c9e6175a-e124-4c80-93f9-17b029bc40cc',
  FOLDER_STATUS_CREATED_CROSSING_DOCUMENTS = 'ce29e68d-00dc-4c7f-be22-a65f05c165f9',
  FOLDER_STATUS_OBSOLETE_CROSSING_DOCUMENTS = '67b7e57a-ae5e-49c7-baef-8e406de5e17a',
  FOLDER_STATUS_BILLING_CHECK = 'c684214e-9bc8-40ee-9dfe-8b1116a2fa93',
  FOLDER_STATUS_FOLDER_CLOSED = '1a432f76-228f-4a7e-880a-7deb6c0f69cd',
}

export enum FOLDER_STATUS_REFERENTIAL_BORDER_CROSSING_RORO_EMPTY_V2 {
  FOLDER_STATUS_PENDING_REQUEST = 'b0e673f7-0ecb-418c-bd5c-d726676f80c3',
  FOLDER_STATUS_EXPIRED_REQUEST = '26a2d0b9-5e7f-4346-9be4-2939fb512404',
  FOLDER_STATUS_CANCELLED_REQUEST = 'f89e8f17-ad2f-4751-9fb9-36ea66aab62f',
  FOLDER_STATUS_PENDING_ORDER = 'e5e7c610-159a-478e-94b5-746b352c29fd',
  FOLDER_STATUS_DOCUMENTARY_INCIDENT = '58cd7d3f-2d3a-4e56-8c97-8d05231f3c0d',
  FOLDER_STATUS_DOCUMENTARY_INCIDENT_TREATED = '651e2544-2800-4d36-90f9-bf55bd14c8e0',
  FOLDER_STATUS_EXPIRED_ORDER = '71257b5e-0700-43f0-bdd4-4dcee32ebaa3',
  FOLDER_STATUS_CANCELLED_ORDER = 'ff659993-91fe-42c7-8ab2-28ed44ee5561',
  FOLDER_STATUS_CREATED_CROSSING_DOCUMENTS = '07992e0d-8a7d-4fc1-b3fb-ce4bc18a3e86',
  FOLDER_STATUS_OBSOLETE_CROSSING_DOCUMENTS = '0c44d863-23e7-4749-8a18-66a5c91c278d',
  FOLDER_STATUS_BILLING_CHECK = 'ad2ab64b-3466-4239-a6dd-b17f6aebfe89',
  FOLDER_STATUS_CLOSED = 'fba09ed1-f09c-4a79-b7f5-031427bc8970',
}
